/**
 * Check if a comma-separated permission string contains a specific role.
 * Case-insensitive, trims whitespace. Backward compatible with single values.
 */
export function hasRole(permissionStr, role) {
  if (!permissionStr || !role) return false;
  return permissionStr
    .split(',')
    .map(r => r.trim().toLowerCase())
    .includes(role.trim().toLowerCase());
}

/**
 * Check if a permission string contains ANY of the given roles.
 */
export function hasAnyRole(permissionStr, roles) {
  return roles.some(role => hasRole(permissionStr, role));
}
